import React, { useState } from 'react';
import styles from './FAQ.module.css';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const FAQS = [
  {
    q: 'How is Reddit marketing different from other platforms like Facebook or Google Ads?',
    a: "Reddit is community-driven, not ad-driven — people value authenticity and hate obvious promotion. Success comes from blending into conversations, providing value, and building trust rather than running direct ads.",
  },
  {
    q: 'How do you promote my business without getting banned or downvoted?',
    a: "We use native strategies — posting from aged accounts, engaging in relevant subreddits, and crafting content that feels organic. The goal is to spark discussion, not push salesy messaging.",
  },
  {
    q: 'What kind of results can I expect (traffic, leads, sales)?',
    a: "Results depend on your niche and offer, but most clients see increased targeted traffic, inbound leads, and brand visibility within niche communities that are hard to reach elsewhere.",
  },
  {
    q: 'Which subreddits will you target for my business?',
    a: "We research and identify high-relevance subreddits where your ideal customers already hang out, based on industry, intent, and engagement levels — not just size.",
  },
  {
    q: 'How long does it take to see results from Reddit marketing?',
    a: "Unlike paid ads, Reddit builds momentum. You can see early traction in 1–2 weeks, but consistent results typically come from ongoing engagement over 4–8 weeks.",
  },
];

function FAQItem({ item }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`${styles.item} ${open ? styles.open : ''}`}>
      <button className={styles.question} onClick={() => setOpen((o) => !o)}>
        <span>{item.q}</span>
        <div className={styles.arrow}>{open ? '×' : '+'}</div>
      </button>
      <div className={styles.answer} style={{ maxHeight: open ? 300 : 0 }}>
        <div className={styles.answerInner}>{item.a}</div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const headRef = useScrollAnimation();

  return (
    <section className={styles.section} id="faq">
      <div className="container">
        <div className={`${styles.head} fade-up`} ref={headRef}>
          <div className="section-label">FAQ</div>
          <h2 className="section-title">Common questions.</h2>
        </div>
        <div className={styles.list}>
          {FAQS.map((faq) => (
            <FAQItem key={faq.q} item={faq} />
          ))}
        </div>
      </div>
    </section>
  );
}
